module.exports = __webpack_public_path__ + "img/CY120035.42e224e5.svg";